import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      padding: [52, 70, 63],
    },
    [theme.breakpoints.up('mobile')]: {
      maxWidth: 1690,
      margin: [0, 'auto'],
      padding: [theme.spacing(7), 70],
    },
  },
  content: {
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },

    [theme.breakpoints.up('mobile')]: {
      flexWrap: 'wrap',
    },
  },
  commitment: {
    width: '100%',
    flexShrink: 0,
    order: 3,
    marginTop: theme.spacing(4),
    '& h6': {
      color: theme.palette.colors.darkBlueGray,
      fontSize: 14,
    },
    '& p': {
      color: theme.palette.colors.blueGraySecondary,
      fontSize: 12,
    },

    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      flex: [1, 1, 0],
      minWidth: 210,
    },

    [theme.breakpoints.up('mobile')]: {
      maxWidth: 373,
      marginTop: 0,
      order: 0,
      flex: 'auto',
      '& h6': {
        fontSize: 20,
        color: theme.palette.colors.black,
      },
      '& p': {
        fontSize: theme.spacing(2),
        color: theme.palette.colors.black,
      },
    },
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: theme.palette.colors.darkBlue,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 20,
      fontWeight: 700,
      marginBottom: theme.spacing(4),
      color: theme.palette.colors.black,
    },
  },
  address: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: 0,
    },
  },
  phone: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: 0,
    },
  },
  text: {
    fontSize: 14,
    color: theme.palette.colors.darkBlue,
    [theme.breakpoints.up('mobile')]: {
      fontSize: theme.spacing(2),
      color: theme.palette.colors.black,
    },
  },
  contacts: {
    order: 1,
    [theme.breakpoints.up('mobile')]: {
      order: 3,
    },
  },
  logo: {
    order: 2,
    [theme.breakpoints.up('md')]: {
      flex: [1, 1, 0],
      display: 'flex',
      justifyContent: 'center',
    },
    [theme.breakpoints.up('mobile')]: {
      order: 1,
      width: 96,
      height: 91,
      flex: 'inherit',
    },
  },
  icon: {
    [theme.breakpoints.up('mobile')]: {
      width: '100%',
      height: '100%',
    },
  },
  description: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(4),
    },
  },
  nav: {
    display: 'none',
    [theme.breakpoints.up('mobile')]: {
      order: 2,
      display: 'block',
    },
  },
  socialButtons: {
    marginTop: theme.spacing(4),
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Footer/useStyles.js